import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { Button, ButtonGroup } from 'reactstrap'

import { parseGa4Accounts, setDisableGA4Override } from '../../../../features/session/sessionSlice'

import { appendModel } from '../../../../features/site/siteSlice'
import { oauthConsts, OVERRIDE_ID_GA, OVERRIDE_ID_UA_TO_GA4 } from '../../../utils/common'
import { alertNoAccountProperties } from '../../../utils/Users'
import SearchDropdown from '../../Layout/Common/SearchDropdown'

const INITIAL_STATE = {
    account: {},
    property: {},
    view: {},
    useGA4: true
}

function GoogleAnalytics(props){    
    const dispatch = useDispatch()
    const [state, setState] = useState(INITIAL_STATE)

    const oauthConst = oauthConsts()

    const isAdmin = useSelector(state => state.session.isAdmin)
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)
    const disableGA4Override = useSelector(state => state.session.disableGA4Override)
    const ga4MetricDateOverride = useSelector(state => state.session.ga4MetricDateOverride)

    const ga4Accounts = useSelector(parseGa4Accounts)
    
    const AddAccParent = (p) => props.design === "onboarding" ? <div className="text-center">
        {p.children}
    </div> : <>{p.children}</>

    useEffect(() => {
        if(state.view !== INITIAL_STATE.view && !state.useGA4 && oauthTokens?.ga?.id && !oauthTokens?.ga?.id?.includes("ga4:")){
            let { account, property, view } = state 
            const map = {
                tokenId: oauthTokens.ga?.id,
                accountName: account.name,
                propertyName: property.name,
                viewId: view.id,
                viewName: view.name
            }
            
            let sForm = {
                ...model.siteForm,
                attr: {
                    ...(model?.siteForm?.attr ?? {}),
                    accounts: {
                        ...(model?.siteForm?.attr?.accounts ? model.siteForm.attr.accounts : []),
                        ga: map
                    }
                }
            }

            localStorage.setItem("gaSelection", JSON.stringify({
                account: account.id,
                accountKey: account.key,
                property: property.id,
                propertyKey: property.key,
                view: view.id,
                viewKey: view.key,
                map: JSON.stringify({...map})
            }))

            dispatch(appendModel({siteForm: sForm}))
            
            props.onSelectionUpdated("ga")
        }
    }, [state.view])

    useEffect(() => {
        if(state.property !== INITIAL_STATE.property && state.useGA4 && oauthTokens?.ga?.id && oauthTokens?.ga?.id?.includes("ga4:")){
            let { account, property } = state 
            const map = {
                tokenId: oauthTokens.ga?.id,
                accountId: account.account,
                accountName: account.displayName,
                propertyName: property.displayName,
                propertyId: property.property,
                goals: model?.siteForm?.attr?.accounts?.ga?.goals ?? undefined
            }
            
            let sForm = {
                ...model.siteForm,
                attr: {
                    ...(model?.siteForm?.attr ?? {}),
                    accounts: {
                        ...(model?.siteForm?.attr?.accounts ? model.siteForm.attr.accounts : []),
                        ga: map
                    }
                }
            }

            localStorage.setItem("ga4Selection", JSON.stringify({
                account: account.account,
                accountKey: account.key,
                property: property.property,
                propertyKey: property.key,
                map: JSON.stringify({...map})
            }))

            dispatch(appendModel({siteForm: sForm}))
            
            props.onSelectionUpdated("ga")
        }
    }, [state.property])

    useEffect(() => {
        if(oauthTokens.ga && !model.siteForm?.attr?.accounts?.ga){

            if(oauthTokens.ga && !oauthTokens?.ga?.id?.includes("ga4:") && !model.siteForm?.attr?.accounts?.ga && localStorage.getItem("gaSelection") !== null){
                const gaSelection = JSON.parse(localStorage.getItem("gaSelection"))
                
                setState(prev => ({
                    ...prev,
                    useGA4: false,
                    account: {...oauthTokens?.ga?.accounts[gaSelection.accountKey], key: gaSelection.accountKey},
                    property: gaSelection.propertyKey ? {...oauthTokens?.ga?.accounts[gaSelection.accountKey].webProperties[gaSelection.propertyKey], key: gaSelection.propertyKey} : {},
                }))
            } else if(oauthTokens.ga && oauthTokens?.ga?.id?.includes("ga4:") && !model.siteForm?.attr?.accounts?.ga && localStorage.getItem("ga4Selection") !== null){
                const gaSelection = JSON.parse(localStorage.getItem("ga4Selection"))
                
                setState(prev => ({
                    ...prev,
                    useGA4: true,
                    account: {...ga4Accounts[gaSelection.accountKey], key: gaSelection.accountKey}
                }))
            } else {

                setState(prev => ({
                    ...prev,
                    useGA4: oauthTokens?.ga?.id?.includes("ga4:")
                }))
            }
        }
    }, [model.siteForm, localStorage.getItem("ga4Selection"), localStorage.getItem("gaSelection"), oauthTokens?.ga])

    useEffect(() => {
        if(props.design === "onboarding" && 
            state.account !== INITIAL_STATE.account &&
            oauthTokens?.ga?.id?.includes("ga4:") && 
            !model.siteForm?.attr?.accounts?.ga &&
            !state.account.propertySummaries){
            toast.warning("It looks like you don't have a Google Analytics 4 property set up. Please toggle to Universal Analytics or click the Help button to contact our staff for assistance", {
                autoClose: false
            })
        }
    }, [state.account])
    
    const { siteForm, sites, siteActiveIdx } = model
    const { account, property, view, useGA4 } = state

    const hrefOauth = `${oauthConst.gaAuthURL(useGA4)}&state=${props.design === "onboarding" ? "/onboarding/" : "/admin/"}${siteForm.siteId}/ga`

    const site = sites[siteActiveIdx]

    const pulseRefreshBtn = (useGA4 && !oauthTokens?.ga?.id?.includes("ga4:")) || (!useGA4 && oauthTokens?.ga?.id?.includes("ga4:"))

    return <>
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && ((sessionStorage.getItem(OVERRIDE_ID_UA_TO_GA4) &&
            siteForm?.attr?.accounts?.ga && oauthTokens?.ga) ||
            (!siteForm?.attr?.accounts?.ga && oauthTokens?.ga && !sessionStorage.getItem(OVERRIDE_ID_GA))) && <>
            <div className="d-flex justify-content-between mb-3">
                {!props.ga4Only && <ButtonGroup>
                    <Button
                        color="primary"
                        outline
                        onClick={() => setState(prev => ({...prev, useGA4: true}))}
                        active={useGA4}>
                        GA4
                    </Button>
                    <Button
                        color="primary"
                        outline
                        onClick={() => setState(prev => ({...prev, useGA4: false}))}
                        active={!useGA4}>
                        Universal
                    </Button>
                </ButtonGroup>}
                {/* <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="ga4toggle" onChange={() => setState(prev => ({...prev, useGA4: !useGA4}))} checked={useGA4 ? "checked" : "" } />
                    <label class="custom-control-label pt-1" htmlFor="ga4toggle">
                        Using {useGA4 ? "Google Analytics 4" : "Universal Analytics"}
                    </label>
                </div> */}
                {props.design === "admin" && <div className="btn-group">
                    <a href={hrefOauth} className={`btn btn-lg btn-info ${pulseRefreshBtn ? "pulse-blue" : ""}`}>
                        <i class="fas fa-sync-alt"></i> Refresh
                    </a>
                </div>}
            </div>
            {props.design === "onboarding" && <div className="d-flex justify-content-end mb-3">
                <div className="btn-group">
                    <a href={hrefOauth} className={`btn btn-lg btn-info ${pulseRefreshBtn ? "pulse-blue" : ""}`}>
                        <i class="fas fa-sync-alt"></i> Refresh
                    </a>
                </div>
            </div>}
            {useGA4 ? (oauthTokens?.ga?.id?.includes("ga4:") ? <form>
                <div class="form-group">
                    <label for="acct">Account</label>
                    <select id="ga-acct" className="form-control" onChange={(e) => setState(prev => ({...prev, property: INITIAL_STATE.property, account: {...ga4Accounts[e.target.value], key: e.target.value}}))} value={account?.key}>
                        <option></option>
                        {ga4Accounts?.length > 0 ? 
                            [...ga4Accounts].map((acct, key) => <option key={key} value={key}>{acct.displayName}</option>) : null}
                    </select>
                </div>
                <div class="form-group">
                    <label for="property">Property</label>
                    {props.design === "admin" ? <SearchDropdown 
                        value={property?.key}
                        defaultValue={""}
                        placeholder={"Choose property"} 
                        className={{
                            container: "w-100"
                        }}
                        onChange={(selected) => {
                            setState(prev => ({
                                ...prev, 
                                property: {...account?.propertySummaries[selected.value], key: selected.value}
                            }))
                        }}
                        options={account?.propertySummaries ? account?.propertySummaries?.map((pty, key) => ({
                            label: pty.displayName,
                            value: key
                        })) : []} /> : <select id="ga-property" className="form-control" onChange={(e) => setState(prev => ({...prev, property: {...account?.propertySummaries[e.target.value], key: e.target.value}}))} value={property?.key}>
                        <option></option>
                        {account?.propertySummaries?.map((pty, key) => <option key={key} value={key}>{pty.displayName}</option>)}
                    </select>}
                </div>
                {props.design === "admin" && isAdmin && (sessionStorage.getItem(OVERRIDE_ID_UA_TO_GA4) &&
                    siteForm?.attr?.accounts?.ga && oauthTokens?.ga) && <>
                    <div class="form-group">
                        <label for="disableOverride">Disable Metric Retrieval</label>
                        <input type="checkbox" className="ml-2" onChange={() => dispatch(setDisableGA4Override(!disableGA4Override))} checked={disableGA4Override ? "checked" : ""} />
                    </div>
                    <div class="form-group">
                        <label for="">Pull GA4 Metrics from this date forward:</label>
                        <input className="form-control" type="date" disabled={disableGA4Override} value={ga4MetricDateOverride} />
                    </div>
                </>}

            </form> : <></>) : (oauthTokens?.ga?.id?.includes("ga4:") ? <></> : <form>
                <div class="form-group">
                    <label for="acct">Account</label>
                    <select id="ga-acct" className="form-control" onChange={(e) => setState(prev => ({...prev, view: INITIAL_STATE.view, property: INITIAL_STATE.property, account: {...oauthTokens?.ga?.accounts[e.target.value], key: e.target.value}}))} value={account?.key}>
                        <option></option>
                        {oauthTokens?.ga?.accounts.map((acct, key) => <option key={key} value={key}>{acct.name}</option>)}
                    </select>
                </div>
                <div class="form-group">
                    <label for="property">Property</label>
                    <select id="ga-property" className="form-control" onChange={(e) => setState(prev => ({...prev, view: INITIAL_STATE.view, property: {...account?.webProperties[e.target.value], key: e.target.value}}))} value={property?.key}>
                        <option></option>
                        {account?.webProperties?.map((pty, key) => <option key={key} value={key}>{pty.name}</option>)}
                    </select>
                </div>
                <div class="form-group">
                    <label for="view">View</label>
                    <select id="ga-view" className="form-control" onChange={(e) => setState(prev => ({...prev, view: {...property?.profiles[e.target.value], key: e.target.value}}))} value={view?.key}>
                        <option></option>
                        {property?.profiles?.map((v, key) => <option key={key} value={key}>{v.name}</option>)}
                    </select>
                </div>
            </form>)}
        </>}
        {siteForm?.attr?.accounts?.ga && <div>
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && sessionStorage.getItem(OVERRIDE_ID_GA) && <h5 className="alert alert-info">
                Click the Save button to complete the reset token process
            </h5>}
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className={`d-flex justify-content-${isAdmin && siteForm?.attr?.accounts?.ga?.refreshRequired ? 'between' : 'end'} mb-3`}>
                {isAdmin && siteForm?.attr?.accounts?.ga?.refreshRequired && <div class="alert alert-danger mb-0" role="alert">
                    <strong>Next Alert Date:</strong> {siteForm?.attr?.accounts?.ga.refreshAlertDate}
                </div>}
                <div className="btn-group">
                    {!sessionStorage.getItem(OVERRIDE_ID_GA) && siteForm?.attr?.accounts?.ga?.refreshRequired && <button className="btn btn-lg btn-danger" onClick={() => props.onResetToken("ga", hrefOauth)}>
                        <i class="fas fa-trash-alt"></i> Reset Token
                    </button>}
                    {(props.design === "admin" && !siteForm?.attr?.accounts?.ga?.tokenId.includes("ga4:")) && <button className="btn btn-lg btn-info" onClick={() => props.onResetToken("ga", `${oauthConst.gaAuthURL(true)}&state=${props.design === "onboarding" ? "/onboarding/" : "/admin/"}${siteForm.siteId}/ga`, true)}>
                        <i class="fas fa-sync-alt"></i> Convert to GA4
                    </button>}
                    {isAdmin && <button className="btn btn-lg btn-outline-danger" onClick={() => props.onDeleteService("ga")}>
                        <i class="fas fa-trash-alt"></i> Delete
                    </button>}
                </div>
            </div>}
            {isAdmin && <div className="d-flex justify-content-start">
                <i className="fas fa-id-badge mr-1 fa-1-5"></i>
                <strong className="mr-1">Token ID: </strong>
                <h5>{siteForm?.attr?.accounts?.ga?.tokenId}</h5>
            </div>}
            <h3>
                <small class="text-muted">Account:</small> <span id="gaAccountName">{siteForm?.attr?.accounts?.ga?.accountName}</span>
            </h3>
            <h3>
                <small className="text-muted">Property:</small> <span id="gaPropertyName">{siteForm?.attr?.accounts?.ga?.propertyName}</span>
            </h3>
            {siteForm?.attr?.accounts?.ga?.viewName && <h3>
                <small className="text-muted">View:</small> <span id="gaViewName">{siteForm?.attr?.accounts?.ga?.viewName}</span>
            </h3>}        
        </div>}
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && !siteForm?.attr?.accounts?.ga && !oauthTokens?.ga && <>
            {!props.ga4Only && <ButtonGroup className="mb-3 d-block">
                <Button
                    color="primary"
                    outline
                    onClick={() => setState(prev => ({...prev, useGA4: true}))}
                    active={useGA4}>
                    GA4
                </Button>
                <Button
                    color="primary"
                    outline
                    onClick={() => setState(prev => ({...prev, useGA4: false}))}
                    active={!useGA4}>
                    Universal
                </Button>
            </ButtonGroup>}
            <AddAccParent>
                <a class="btn btn-success btn-lg" href={hrefOauth}>Add Account</a>
            </AddAccParent>
        </>}
    </>
}

GoogleAnalytics.defaultProps = {
    design: "admin",
    ga4Only: false,
    onSelectionUpdated: () => null
}

export default GoogleAnalytics